import { ParameterInputProps } from "./types";

import { Input } from "@/components/ui/input";

const getInputValue = (
  value: string | number | undefined,
  defaultValue: string | number | undefined,
): string => {
  if (value !== undefined) {
    return String(value);
  }

  if (defaultValue !== undefined) {
    return defaultValue.toString();
  }

  return "";
};

export const ParameterInput = ({
  onChange,
  value,
  defaultValue,
  type,
  isDisabled,
  placeholder,
  readOnly,
  isPreview,
}: ParameterInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "text") {
      onChange(e.target.value);
      return;
    }
    const numValue = e.target.value.replace(/[^0-9.]/g, "");

    onChange(numValue);
  };

  const inputValue = getInputValue(value, defaultValue);

  const previewValue =
    isPreview && typeof defaultValue === "number" && Number.isNaN(defaultValue)
      ? inputValue
      : defaultValue;

  const getPreviewDisplayValue = () => {
    if (previewValue === undefined || previewValue === null) {
      return "";
    }

    return String(previewValue);
  };

  return (
    <Input
      disabled={isDisabled}
      readOnly={readOnly}
      defaultValue={isPreview ? inputValue || "" : defaultValue}
      value={isPreview ? getPreviewDisplayValue() : inputValue}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );
};
